<template>
  <div class="featured-categories container container--page-content">
    <SharedHeadlineWithCta
      :title="component.featuredCategoriesTitle"
      :description="component.featuredCategoriesDescription"
      :cta="component.featuredCategoriesCta"
      :invertedColor="component.featuredCategoriesInvertedColor"
    />
    <div
      class="featured-categories__categories mt-8 lg:mt-10 grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-8"
      v-if="component.categories?.length"
    >
      <NuxtLink
        v-for="(category, i) in component.categories"
        :key="i"
        :to="category.url"
        :title="category.name"
        class="featured-categories__category flex flex-col gap-2 w-full"
      >
        <SharedPicture
          :media="category.image"
          class="w-full !block md:!h-44 object-cover object-center rounded-sm overflow-hidden"
          height="176"
          width="280"
          format="webp"
          :quality="80"
        />
        <p class="featured-categories__category-name text-medium-semibold"
        :class="{ '!text-white': component.featuredCategoriesInvertedColor }"
        >{{ category.name }}</p>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { GraphQLFeaturedCategories } from '~/types/graphql';

  const props = defineProps<{
    component: GraphQLFeaturedCategories;
    index: number;
  }>();
</script>

<style scoped lang="scss">
  .featured-categories__category {
    transition: all 0.3s ease-in-out;
    &:hover {
      transform: translateY(-5px);
    }
  }
</style>
